export default __webpack_public_path__ + "static/media/hht1_storybook_04.9be83223.png";